import { Button } from "@chakra-ui/react";
import { BlockchainTypes, CrossmintEVMWalletAdapter } from "@crossmint/connect";
import { useState } from "react";

// const apiKey = "sk_live.93f8ca4e.ae766d0c2e478cd5a8276343de08e2ff";

const _crossmintConnect = new CrossmintEVMWalletAdapter({
  chain: BlockchainTypes.ETHEREUM,
});

const CrossmintButton = ({
  setAddress,
}: {
  setAddress: (val: string) => void;
}) => {
  const [loading, setLoading] = useState(false);

  async function connectToCrossmint() {
    try {
      setLoading(true);
      const address = await _crossmintConnect.connect();
      if (address) {
        setAddress(address);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  // useEffect(() => {
  //   setAddress("0xbb99B4Bce1929aE8BF17496f2e77094C2961abFE");
  // }, []);

  return (
    <Button isLoading={loading} onClick={connectToCrossmint} w="100%">
      Log In w/ Crossmint
    </Button>
  );
};

export default CrossmintButton;
